// Code generated by protoc-gen-zeroapi. DO NOT EDIT.

import service from '@/lobby_common/utils/request'

// 支付收银台
// Req : open_proto.client.v1.payment.GetRechargeModelReq
// Resp: open_proto.client.v1.payment.GetRechargeModelResp
export const getRechargeModel = (data) => {
  return service({
    url: '/v1/payment/getRechargeModel',
    method: 'post',
    data
  })
}
// 代付收银台
// Req : open_proto.common.Undefined
// Resp: open_proto.client.v1.payment.GetWithdrawModelResp
export const getWithdrawModel = (data) => {
  return service({
    url: '/v1/payment/getWithdrawModel',
    method: 'post',
    data
  })
}
// 用户充值
// Req : open_proto.client.v1.payment.UserRechargeReq
// Resp: open_proto.client.v1.payment.UserRechargeResp
export const userRecharge = (data) => {
  return service({
    url: '/v1/payment/userRecharge',
    method: 'post',
    data
  })
}
// 用户二次充值
// Req : open_proto.client.v1.payment.UserSecondRechargeReq
// Resp: open_proto.client.v1.payment.UserSecondRechargeResp
export const userSecondRecharge = (data) => {
  return service({
    url: '/v1/payment/userSecondRecharge',
    method: 'post',
    data
  })
}
// 用户提现
// Req : open_proto.client.v1.payment.UserWithdrawReq
// Resp: open_proto.client.v1.payment.UserWithdrawResp
export const userWithdraw = (data) => {
  return service({
    url: '/v1/payment/userWithdraw',
    method: 'post',
    data
  })
}
// 用户活动提现
// Req : open_proto.client.v1.payment.UserActivityWithdrawReq
// Resp: open_proto.client.v1.payment.UserWithdrawResp
export const userActivityWithdraw = (data) => {
  return service({
    url: '/v1/payment/userActivityWithdraw',
    method: 'post',
    data
  })
}
// 支付订单列表
// Req : open_proto.client.v1.payment.RechargeOrderListReq
// Resp: open_proto.client.v1.payment.RechargeOrderListResp
export const rechargeOrderList = (data) => {
  return service({
    url: '/v1/payment/orderList',
    method: 'post',
    data
  })
}
// 代付订单列表
// Req : open_proto.client.v1.payment.WithdrawOrderListReq
// Resp: open_proto.client.v1.payment.WithdrawOrderListResp
export const withdrawOrderList = (data) => {
  return service({
    url: '/v1/payment/withdrawOrderList',
    method: 'post',
    data
  })
}
// 通过订单号获取支付订单列表
// Req : open_proto.client.v1.payment.RechargeOrderListByOrderNumbersReq
// Resp: open_proto.client.v1.payment.RechargeOrderListByOrderNumbersResp
export const rechargeOrderListByOrderNumbers = (data) => {
  return service({
    url: '/v1/payment/orderListByOrderNumbers',
    method: 'post',
    data
  })
}
// 通过订单号获取代付订单列表
// Req : open_proto.client.v1.payment.WithdrawOrderListByOrderNumbersReq
// Resp: open_proto.client.v1.payment.WithdrawOrderListByOrderNumbersResp
export const withdrawOrderListByOrderNumbers = (data) => {
  return service({
    url: '/v1/payment/withdrawOrderListByOrderNumbers',
    method: 'post',
    data
  })
}
// 查看用户提现剩余额度
// Req : open_proto.client.v1.payment.WithdrawRemainingReq
// Resp: open_proto.client.v1.payment.WithdrawRemainingResp
export const withdrawRemaining = (data) => {
  return service({
    url: '/v1/payment/withdrawRemaining',
    method: 'post',
    data
  })
}
// 用户提现预览
// Req : open_proto.client.v1.payment.UserWithdrawReq
// Resp: open_proto.client.v1.payment.UserWithdrawPreviewResp
export const userWithdrawPreview = (data) => {
  return service({
    url: '/v1/payment/userWithdrawPreview',
    method: 'post',
    data
  })
}
// 设置提现密码
// Req : open_proto.client.v1.payment.SetWithdrawPasswordReq
// Resp: open_proto.common.Undefined
export const setWithdrawPassword = (data) => {
  return service({
    url: '/v1/payment/setWithdrawPassword',
    method: 'post',
    data
  })
}
// 代收回调
// Req : open_proto.client.v1.payment.RechargeCallbackReq
// Resp: open_proto.client.v1.payment.RechargeCallbackResp
export const rechargeCallback = (data) => {
  return service({
    url: '/v1/payment/rechargeCallback',
    method: 'post',
    data
  })
}
// 代付回调
// Req : open_proto.client.v1.payment.WithdrawCallbackReq
// Resp: open_proto.client.v1.payment.WithdrawCallbackResp
export const withdrawCallback = (data) => {
  return service({
    url: '/v1/payment/withdrawCallback',
    method: 'post',
    data
  })
}
// 用户充值详情
// Req : open_proto.client.v1.payment.UserRechargeDetailReq
// Resp: open_proto.client.v1.payment.UserRechargeDetailResp
export const userRechargeDetail = (data) => {
  return service({
    url: '/v1/payment/userRechargeDetail',
    method: 'post',
    data
  })
}
// 转账
// Req : open_proto.client.v1.payment.TransferReq
// Resp: open_proto.client.v1.payment.TransferResp
export const transfer = (data) => {
  return service({
    url: '/v1/payment/transfer',
    method: 'post',
    data
  })
}
// 获取用户交易记录
// Req : open_proto.client.v1.payment.GetUserWalletRecordReq
// Resp: open_proto.client.v1.payment.GetUserWalletRecordResp
export const getUserWalletRecord = (data) => {
  return service({
    url: '/v1/payment/getUserWalletRecord',
    method: 'post',
    data
  })
}
// starpay获取法币金额限额
// Req : open_proto.client.v1.payment.GetStarPayGatewayBuyCoinRangeReq
// Resp: open_proto.client.v1.payment.GetStarPayGatewayBuyCoinRangeResp
export const getStarPayGatewayBuyCoinRange = (data) => {
  return service({
    url: '/v1/payment/getStarPayGatewayBuyCoinRange',
    method: 'post',
    data
  })
}
// 获取赠礼记录
// Req : open_proto.client.v1.payment.GiftRecordListReq
// Resp: open_proto.client.v1.payment.GiftRecordListResp
export const giftRecordList = (data) => {
  return service({
    url: '/v1/payment/giftRecordList',
    method: 'post',
    data
  })
}
// 获取用户首充提示
// Req : open_proto.client.v1.payment.GetUserFirstWithdrawHintReq
// Resp: open_proto.client.v1.payment.GetUserFirstWithdrawHintResp
export const getUserFirstWithdrawHint = (data) => {
  return service({
    url: '/v1/payment/getUserFirstWithdrawHint',
    method: 'post',
    data
  })
}
// 获取用户首提信息
// Req : open_proto.client.v1.payment.GetUserFirstWithdrawInfoReq
// Resp: open_proto.client.v1.payment.GetUserFirstWithdrawInfoResp
export const getUserFirstWithdrawInfo = (data) => {
  return service({
    url: '/v1/payment/getUserFirstWithdrawInfo',
    method: 'post',
    data
  })
}
// 银商订单申请
// Req : open_proto.client.v1.payment.SilverOrderApplyReq
// Resp: open_proto.client.v1.payment.SilverOrderApplyResp
export const silverOrderApply = (data) => {
  return service({
    url: '/v1/payment/silverOrderApply',
    method: 'post',
    data
  })
}
// 银商上下分记录
// Req : open_proto.client.v1.payment.SilverOrderListReq
// Resp: open_proto.client.v1.payment.SilverOrderListResp
export const silverOrderList = (data) => {
  return service({
    url: '/v1/payment/silverOrderList',
    method: 'post',
    data
  })
}
// 转账预览
// Req : open_proto.client.v1.payment.TransferReq
// Resp: open_proto.client.v1.payment.TransferPreviewResp
export const transferPreview = (data) => {
  return service({
    url: '/v1/payment/transferPreview',
    method: 'post',
    data
  })
}
// 出款金额预览
// Req : open_proto.client.v1.payment.WithdrawAmountPreviewReq
// Resp: open_proto.client.v1.payment.WithdrawAmountPreviewResp
export const withdrawAmountPreview = (data) => {
  return service({
    url: '/v1/payment/withdrawAmountPreview',
    method: 'post',
    data
  })
}
// 获取充值收银台（精简版）
// Req : open_proto.client.v1.payment.GetRechargeModelReq
// Resp: open_proto.client.v1.payment.GetRechargeModelResp
export const getRechargeModelWithConcise = (data) => {
  return service({
    url: '/v1/payment/getRechargeModelWithConcise',
    method: 'post',
    data
  })
}
// 获取充值礼包列表
// Req : open_proto.client.v1.payment.RechargeGiftListReq
// Resp: open_proto.client.v1.payment.RechargeGiftListResp
export const getRechargeGiftList = (data) => {
  return service({
    url: '/v1/payment/getRechargeGiftList',
    method: 'post',
    data
  })
}
// 免费金币提现信息，在免费金币现金打码模式下使用
// Req : open_proto.client.v1.payment.FreeGoldWithdrawInfoReq
// Resp: open_proto.client.v1.payment.FreeGoldWithdrawInfoResp
export const freeGoldWithdrawInfo = (data) => {
  return service({
    url: '/v1/payment/freeGoldWithdrawInfo',
    method: 'post',
    data
  })
}
// 未升级体现引导信息
// Req : open_proto.client.v1.payment.WithdrawGuideInfoReq
// Resp: open_proto.client.v1.payment.WithdrawGuideInfoResp
export const withdrawGuideInfo = (data) => {
  return service({
    url: '/v1/payment/withdrawGuideInfo',
    method: 'post',
    data
  })
}
// 获取最后一条未完成的订单
// Req : open_proto.client.v1.payment.GetWaitRechargeOrderDetailReq
// Resp: open_proto.client.v1.payment.GetWaitRechargeOrderDetailResp
export const getWaitRechargeOrderDetail = (data) => {
  return service({
    url: '/v1/payment/getWaitRechargeOrderDetail',
    method: 'post',
    data
  })
}
// 获取用户信用卡
// Req : open_proto.common.Undefined
// Resp: open_proto.client.v1.payment.UserCreditCard
export const getUserCreditCard = (data) => {
  return service({
    url: '/v1/payment/getUserCreditCard',
    method: 'post',
    data
  })
}
// 更新用户信用卡
// Req : open_proto.client.v1.payment.UserCreditCard
// Resp: open_proto.common.ModifyResp
export const updateUserCreditCard = (data) => {
  return service({
    url: '/v1/payment/updateUserCreditCard',
    method: 'post',
    data
  })
}
